
export const pad = (value: number, size: number = 2): string => {
    const vs = value.toString();
    if (vs.length >= size)
        return vs;

    const s = "000000000" + value;
    return s.substr(s.length - size);
}